// IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)
// ДАТА УТВЕРЖДЕНИЯ В ПОДПИСИ СТРОКИ ПЛАНА («Stage · responsible · version», поле plan_label Баланса, DS-PLAN-DOCS).
// Контракт бэка (ie-dm7, PR #527, common_modules/plan_docs_balance.py): в тексте plan_label вместо даты — плейсхолдер «{approval_at}», рядом поле строки
// approval_at — ISO UTC без секунд «2026-10-16T12:26Z». Фронт показывает дату в поясе пользователя общей функцией mainStore.formatDateHTML(approval_at, true)
// (без лишних «:00» — opts.secondsIfGiven). Нет метки — бэк отдаёт подпись без плейсхолдера (дата текстом, как раньше): её не трогаем.
// Плейсхолдер без значения approval_at (строка группы, отчёт без поля approval_at) — убирается вместе с соседним разделителем « · », «{approval_at}» не показывается.
// Выключатель fe.ux.m03StampDateFormat (дефолт ВКЛ): выкл — плейсхолдер заменяется ISO-строкой approval_at как есть.
// Контракт v2 (ie-dm7 #110241): дата прямо в тексте — токен «{approval_at:2026-10-16T12:26Z}» (ISO UTC, Z, без секунд); поле строки не нужно. Токен с валидной
// датой — formatDateHTML(iso, true, {secondsIfGiven}) / текстовая форма; без валидной даты — содержимое как есть, без скобок и «approval_at:»; пустой — убирается
// с разделителем. Голый «{approval_at}» (вид v1) — по полю строки approval_at, если оно есть, иначе убирается. Выключатель выкл — ISO как есть, без скобок.
// Чистая логика без Vue / DOM (DOM-часть — AttrGrid.planLabelDate_cellApply). Юнит — tests/unit/planLabelDate.test.mjs

export const APPROVAL_AT_FIELD = 'approval_at'
export const APPROVAL_AT_PH = '{' + APPROVAL_AT_FIELD + '}'
export const PLAN_LABEL_DATE_FLAG = 'fe.ux.m03StampDateFormat'

const escHtml = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
const tagsOff = (h) => String(h ?? '').replace(/<[^>]*>/g, '')
const ISO_RE = /^\d{4}-\d\d-\d\d[T ]\d\d:\d\d/

// токен даты: «{approval_at}» (v1) или «{approval_at:<значение>}» (v2)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)
const TOKEN_RE = /(\{approval_at(?::[^{}]*)?\})/
// есть ли в тексте плейсхолдер / токен даты
export function planLabel_hasPh(text) {
    return typeof text === 'string' && text.indexOf('{' + APPROVAL_AT_FIELD) >= 0 && TOKEN_RE.test(text)
}

// значение approval_at строки грида: поле строки; у строки-группы wijmo (items) — общее значение её строк, разные / нет — ''
export function planLabel_approvalAt(dataItem) {
    if (!dataItem || typeof dataItem !== 'object') return ''
    const v = dataItem[APPROVAL_AT_FIELD]
    if (typeof v === 'string') return v.trim()
    const items = Array.isArray(dataItem.items) ? dataItem.items : null
    if (!items) return ''
    let one = ''
    for (const it of items) {
        const x = planLabel_approvalAt(it)
        if (!x) continue
        if (one && x !== one) return ''
        one = x
    }
    return one
}

// дата для подстановки: { text, html }. fmt — mainStore.formatDateHTML (inputDate, utc_to_local, opts). on — выключатель (выкл — ISO как есть)
export function planLabel_dateParts(at, { on = true, fmt = null } = {}) {
    const iso = String(at ?? '').trim()
    if (!iso) return { text: '', html: '' }
    if (!on || typeof fmt !== 'function' || !ISO_RE.test(iso)) return { text: iso, html: escHtml(iso) }
    let h = ''
    try { h = String(fmt(iso, true, { secondsIfGiven: true }) ?? '') } catch (e) { h = '' }
    const text = tagsOff(h).trim()
    if (!text || /NaN/.test(text)) return { text: iso, html: escHtml(iso) }
    return { text, html: `<span class="plan-label-date">${h}</span>` }
}

// подпись с подставленной датой. html = false — текст (подсказка, копирование, выгрузка); html = true — HTML ячейки (окружающий текст экранирован).
// at — поле строки approval_at (только для голого «{approval_at}» v1). Без токена — label как есть (не строка — тоже как есть)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)
export function planLabel_fill(label, at, { on = true, fmt = null, html = false } = {}) {
    if (!planLabel_hasPh(label)) return label
    const seg = label.split(TOKEN_RE).map((x, i) => {
        if (i % 2 === 0) return { text: x }
        const v = x.length > APPROVAL_AT_PH.length ? x.slice(APPROVAL_AT_PH.length, -1) : at   // «{approval_at:` … `}» → значение; голый — поле строки
        return { tok: true, d: planLabel_dateParts(v, { on, fmt }) }
    })
    // пустой токен — убрать вместе с одним соседним разделителем «·» (сначала предшествующим, иначе последующим)
    for (let i = 1; i < seg.length; i += 2) {
        if (seg[i].d.text) continue
        if (/\s*·\s*$/.test(seg[i - 1].text)) seg[i - 1].text = seg[i - 1].text.replace(/\s*·\s*$/, '')
        else if (i + 1 < seg.length && /^\s*·\s*/.test(seg[i + 1].text)) seg[i + 1].text = seg[i + 1].text.replace(/^\s*·\s*/, '')
    }
    return seg.map(x => x.tok ? (html ? x.d.html : x.d.text) : (html ? escHtml(x.text) : x.text)).join('')
}

// IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана): ЕДИНЫЙ ХЕЛПЕР ТЕКСТА БУФЕРА — все пути копирования ячеек грида.
// Бой 27.10 (бот ie-dm7, r32, строка Роаккутан): клик мышью по уже выделенной ячейке подписи открывает редактор wijmo (INPUT.wj-grid-editor) со значением
// getCellData = сырой токен; Ctrl+C в редакторе — родное копирование выделения поля, мимо copying/copy_collect → в буфере «{approval_at:…}».
// Второй путь мимо copy_collect — копирование самого wijmo (copying не отменён: нет своих ячеек / нет async clipboard) и выгрузка CSV: flex.getClipString.
// planLabel_copyText — текст с токеном → текстовая форма даты (без токена — как есть); planLabel_hookGrid — крючки грида: getClipString и copy в редакторе.

// текст для буфера / выгрузки: токен даты → текстовая форма (planLabel_fill, html = false); не строка или без токена — как есть
export function planLabel_copyText(text, at, opts = {}) {
    if (!planLabel_hasPh(text)) return text
    return planLabel_fill(text, at, { ...(opts || {}), html: false })
}

// copy в редакторе ячейки (INPUT / TEXTAREA): выделенный текст с токеном → текстовая форма в text/plain (родное копирование отменено).
// getOpts() → { on, fmt }; getAt() → approval_at строки редактора (для голого «{approval_at}» v1). → true, если буфер записан
export function planLabel_onEditorCopy(e, getOpts, getAt) {
    const el = e && e.target
    if (!el || (el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA') || !e.clipboardData) return false
    const v = String(el.value ?? '')
    const s = el.selectionStart, t = el.selectionEnd
    const part = (Number.isInteger(s) && Number.isInteger(t) && t > s) ? v.slice(s, t) : ''
    if (!part || !planLabel_hasPh(part)) return false
    let out = part
    try { out = planLabel_copyText(part, typeof getAt === 'function' ? getAt() : '', typeof getOpts === 'function' ? getOpts() : {}) } catch (err) { return false }
    e.clipboardData.setData('text/plain', out)
    e.preventDefault()
    return true
}

// крючки грида wijmo (один раз на экземпляр): getClipString (Ctrl+C путём wijmo, CSV-выгрузка) и копирование из редактора ячейки (copy на хосте, фаза захвата).
// getOpts() → { on, fmt }; getAt() → approval_at строки редактора. → true, если крючки поставлены сейчас
export function planLabel_hookGrid(flex, getOpts, getAt) {
    if (!flex || flex.__planLabelHook) return false
    flex.__planLabelHook = true
    const og = flex.getClipString
    if (typeof og === 'function') {
        flex.getClipString = function (...args) {
            const s = og.apply(this, args)
            try { return planLabel_copyText(s, '', typeof getOpts === 'function' ? getOpts() : {}) } catch (err) { return s }
        }
    }
    const host = flex.hostElement
    if (host && typeof host.addEventListener === 'function') host.addEventListener('copy', (e) => { try { planLabel_onEditorCopy(e, getOpts, getAt) } catch (err) { /* копия как есть */ } }, true)
    return true
}

// IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана): ячейка с токеном даты — только чтение (подпись плана вычисляет BE, правка не сохраняется;
// открытый редактор показывал бы сырой «{approval_at:…}»). on — выключатель fe.ux.m03StampDateFormat (выкл — как до правки)
export function planLabel_editLocked(value, on = true) {
    return on !== false && planLabel_hasPh(value)
}
